import PersonIcon from "@mui/icons-material/Person";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import LayersIcon from "@mui/icons-material/Layers";
import BusinessIcon from "@mui/icons-material/Business";
import FlagIcon from "@mui/icons-material/Flag";
import GlobalChip from "../../../shared/utils/GlobalChip";
import { Box } from "@mui/material";
import GlobalButton from "../../../shared/utils/GlobalButton";

const TicketCard = ({ ticket, onAction, loading }) => {
  const formatDateTime = (timestamp) => {
    if (!timestamp) return "";

    const date = new Date(timestamp);

    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };
  return (
    <div className="flex flex-col overflow-hidden rounded-xl border border-[#E6E8EC] bg-white">
      <div className="flex flex-1 flex-col p-3">
        <div
          style={{
            height: "200px",
            borderRadius: "6px",
            border: "1px solid #cccccc ",
            marginBottom: "8px",
          }}
        >
          <img
            src={
              ticket.status === "Flagged"
                ? ticket?.installationImage
                : ticket?.resolvedInstallationImage
            }
            alt="Installation"
            className="w-full h-full object-contain"
          />
        </div>
        <div className="mb-2 flex items-center justify-between">
          <GlobalChip label={`# ${ticket.ticketNumber}`} />
          <div className="flex items-center gap-1.5">
            <GlobalChip label={ticket?.flagIssue} type="warning" />
            <img
              src={
                ticket.status === "Flagged"
                  ? "/assests/AdminDashboard/flag_filled.png "
                  : "/assests/AdminDashboard/flag_green.png"
              }
              width={30}
              height={30}
              alt="flag"
              className="mx-2"
            />
          </div>
        </div>

        {/* Title */}
        <h5 className="font-semibold text-primary mb-2">
          {ticket?.productId?.productType}
        </h5>

        {/* Vendor */}
        <div className="flex items-center mb-2">
          <p className="text-primary font-medium mr-2">Vendor: </p>
          <p className="font-medium text-anchor ">
            {ticket?.vendorId?.vendorBusinessName}
          </p>
        </div>

        {/* Description */}
        <div className="relative p-3 h-[84px] bg-[#f2f2f2] border-sm  overflow-hidden overflow-y-auto mb-4">
          <h6 className="text-secondary font-small">
            {ticket.status === "Flagged"
              ? ticket?.description
              : ticket?.resolvedRemarks}
          </h6>
        </div>

        {/* Owner + Date */}
        <div className="mb-[15px] flex justify-between ">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <img
              src="/assests/AdminDashboard/user-round.png"
              alt="campaign"
              style={{
                width: "14px",
                height: "14px",
                objectFit: "contain",
                flexShrink: 0,
              }}
            />

            <p className="font-medium text-primary">
              {ticket?.status === "Flagged"
                ? ticket?.flaggedBy?.name
                : ticket?.resolvedBy?.name}
            </p>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <img
              src="/assests/AdminDashboard/calendar-days.png"
              alt="campaign"
              style={{
                width: "14px",
                height: "14px",
                objectFit: "contain",
                flexShrink: 0,
              }}
            />

            <p className="font-medium text-primary">
              {ticket?.status === "Flagged"
                ? formatDateTime(ticket?.flaggedAt)
                : formatDateTime(ticket?.resolvedAt)}
            </p>
          </Box>
        </div>

        {/* Campaign */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "15px",
          }}
        >
          <img
            src="/assests/AdminDashboard/campaign.png"
            alt="campaign"
            style={{
              width: "14px",
              height: "14px",
              objectFit: "contain",
              flexShrink: 0,
            }}
          />

          <p className="font-medium text-primary">
            {ticket?.campaignId?.campaignTitle}
          </p>
        </Box>

        {/* Company */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "15px",
          }}
        >
          <img
            src="/assests/AdminDashboard/store.png"
            alt="campaign"
            style={{
              width: "14px",
              height: "14px",
              objectFit: "contain",
              flexShrink: 0,
            }}
          />

          <p className="font-medium text-primary">{ticket?.storeName}</p>
        </Box>

        <GlobalButton
          size="medium"
          onClick={() => onAction?.(ticket)}
          variant={ticket?.status == "Flagged" ? "primary" : "secondary"}
          disabled={loading}
        >
          {ticket?.status == "Flagged" ? "Resolve" : "View Details"}
        </GlobalButton>
      </div>
    </div>
  );
};

export default TicketCard;
